__turbopack_context__.v({
  "container": "xlhU2q_container",
  "icon": "xlhU2q_icon",
});
